export enum ProducerDrawerParams {
  Id = 'id',
  ProducerId = 'producerId',
  ProducerEntityType = 'producerEntityType',
  ProducerName = 'producerName',
  ProducerNumber = 'producerNumber',
}
